import { Helmet } from 'react-helmet-async';
import './landing-variants.css';

const features = [
  { icon: '📅', title: 'Agenda intuitif', desc: 'Vos créneaux s\'organisent naturellement. Confirmations automatiques, rappels SMS inclus.' },
  { icon: '🦷', title: 'Dossier patient', desc: 'Toutes les données cliniques au bon moment, dans un espace clair et structuré.' },
  { icon: '💳', title: 'Facturation simplifiée', desc: 'Devis en un clic, paiements suivis, relances douces et automatiques.' },
  { icon: '📊', title: 'Tableau de bord', desc: 'Visualisez l\'activité du jour, les tendances et les alertes en temps réel.' },
  { icon: '🔒', title: 'Sécurité native', desc: 'Données chiffrées, accès contrôlé, conformité RGPD intégrée par design.' },
  { icon: '🏥', title: 'Multi-cabinet', desc: 'Gérez plusieurs sites depuis un espace unique avec isolation totale des données.' },
];

const testimonials = [
  { name: 'Dr. Amara S.', role: 'Orthodontiste, Casablanca', text: 'doctif a transformé notre façon de gérer les rendez-vous. Plus aucun trou dans le planning.' },
  { name: 'Dr. Karim B.', role: 'Chirurgien-dentiste, Rabat', text: 'L\'interface est claire, rapide, et mes patients adorent la prise de rendez-vous en ligne.' },
];

export default function LandingV3() {
  return (
    <div className="doctif-page" style={{
      fontFamily: "'Nunito', sans-serif", color: '#1a1a2e', background: '#fafcff',
      overflow: 'hidden',
    }}>
      <Helmet><title>doctif — Votre cabinet, simplifié</title></Helmet>

      {/* Animated aurora orbs */}
      <div aria-hidden style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none', overflow: 'hidden' }}>
        <div style={{
          position: 'absolute', width: 500, height: 500, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(147,197,253,0.35), transparent 70%)',
          top: -100, right: -100, animation: 'doctifOrb 12s ease-in-out infinite',
        }} />
        <div style={{
          position: 'absolute', width: 600, height: 600, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(196,181,253,0.25), transparent 70%)',
          bottom: -150, left: -150, animation: 'doctifOrb 15s ease-in-out infinite reverse',
        }} />
        <div style={{
          position: 'absolute', width: 400, height: 400, borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(167,243,208,0.2), transparent 70%)',
          top: '40%', left: '50%', animation: 'doctifOrb 18s ease-in-out infinite 3s',
        }} />
      </div>

      {/* ── Header ── */}
      <header className="doctif-shell" style={{
        padding: '22px 0', position: 'relative', zIndex: 10,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{
            fontFamily: "'Syne', sans-serif", fontSize: 30, fontWeight: 700, color: '#1a1a2e',
            letterSpacing: '-0.03em',
          }}>
            doctif<span style={{ color: '#93c5fd' }}>.</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <nav className="doctif-chip-row">
              <a className="doctif-chip" href="/1/" style={{ background: '#f0f0f8', color: '#666', border: '1px solid #e2e2ee' }}>01</a>
              <a className="doctif-chip" href="/2/" style={{ background: '#f0f0f8', color: '#666', border: '1px solid #e2e2ee' }}>02</a>
              <a className="doctif-chip" href="/3/" style={{ background: '#1a1a2e', color: '#fff' }}>03</a>
            </nav>
            <a href="/accounts/login/" style={{
              background: '#1a1a2e', color: '#fff', textDecoration: 'none',
              padding: '8px 18px', borderRadius: 999, fontWeight: 700, fontSize: 14,
            }}>Se connecter</a>
          </div>
        </div>
      </header>

      {/* ── Hero ── */}
      <section className="doctif-shell" style={{
        position: 'relative', zIndex: 5, paddingTop: 60, paddingBottom: 50, textAlign: 'center',
      }}>
        <div className="doctif-fade-up" style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          background: 'rgba(147,197,253,0.15)', border: '1px solid rgba(147,197,253,0.3)',
          borderRadius: 999, padding: '6px 16px', fontSize: 13, color: '#3b5998', fontWeight: 600,
          marginBottom: 24,
        }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#93c5fd' }} />
          Nouveau : Réservation en ligne intégrée
        </div>

        <h1 className="doctif-fade-up doctif-delay-1" style={{
          fontFamily: "'Syne', sans-serif", fontWeight: 700,
          fontSize: 'clamp(2.6rem, 7vw, 5.5rem)', lineHeight: 1.0,
          maxWidth: 700, margin: '0 auto 24px', letterSpacing: '-0.04em',
        }}>
          <span style={{ color: '#1a1a2e' }}>Gérez votre cabinet</span>
          <br />
          <span style={{
            background: 'linear-gradient(135deg, #93c5fd, #c4b5fd, #a7f3d0)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>avec sérénité.</span>
        </h1>

        <p className="doctif-fade-up doctif-delay-2" style={{
          maxWidth: 560, margin: '0 auto 32px', fontSize: 18, lineHeight: 1.7,
          color: '#6b7280',
        }}>
          doctif réunit agenda, dossiers patients et facturation dans une interface 
          lumineuse et apaisante. Conçu pour les praticiens qui veulent se concentrer 
          sur l'essentiel.
        </p>

        <div className="doctif-fade-up doctif-delay-3" style={{
          display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap',
        }}>
          <a href="/accounts/login/" style={{
            background: '#1a1a2e', color: '#fff', padding: '14px 28px', borderRadius: 14,
            fontWeight: 700, fontSize: 16, textDecoration: 'none',
            boxShadow: '0 12px 40px rgba(26,26,46,0.2)',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}>
            Démarrer gratuitement
          </a>
          <a href="/booking" style={{
            background: 'rgba(255,255,255,0.7)', backdropFilter: 'blur(10px)',
            color: '#1a1a2e', padding: '14px 28px', borderRadius: 14,
            fontWeight: 700, fontSize: 16, textDecoration: 'none',
            border: '1px solid rgba(147,197,253,0.3)',
          }}>
            Voir la démo
          </a>
        </div>
      </section>

      {/* ── Dashboard preview glass card ── */}
      <section className="doctif-shell" style={{ position: 'relative', zIndex: 5, paddingBottom: 60 }}>
        <div className="doctif-fade-up doctif-delay-4" style={{
          background: 'rgba(255,255,255,0.6)', backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.8)', borderRadius: 24,
          padding: 24, boxShadow: '0 30px 60px -20px rgba(147,197,253,0.2)',
          maxWidth: 860, margin: '0 auto',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div>
              <div style={{ fontSize: 12, color: '#9ca3af', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Aperçu clinique</div>
              <div style={{ fontFamily: "'Syne', sans-serif", fontSize: 22, fontWeight: 700, marginTop: 4 }}>Mardi 25 Mars</div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              {['8 RDV', '2 urgences', '94% ponctualité'].map((tag, i) => (
                <span key={tag} style={{
                  padding: '4px 12px', borderRadius: 999, fontSize: 12, fontWeight: 600,
                  background: i === 0 ? '#93c5fd22' : i === 1 ? '#fca5a522' : '#a7f3d022',
                  color: i === 0 ? '#3b82f6' : i === 1 ? '#ef4444' : '#10b981',
                  border: `1px solid ${i === 0 ? '#93c5fd44' : i === 1 ? '#fca5a544' : '#a7f3d044'}`,
                }}>{tag}</span>
              ))}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
            {[
              { time: '08:30', name: 'M. Benali', type: 'Contrôle', color: '#93c5fd' },
              { time: '09:15', name: 'Mme. Idrissi', type: 'Détartrage', color: '#c4b5fd' },
              { time: '10:00', name: 'M. Lahlou', type: 'Prothèse', color: '#a7f3d0' },
            ].map(a => (
              <div key={a.time} style={{
                background: 'rgba(255,255,255,0.8)', borderRadius: 14,
                padding: '14px 12px', borderLeft: `3px solid ${a.color}`,
              }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e' }}>{a.time}</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1a2e', marginTop: 4 }}>{a.name}</div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 2 }}>{a.type}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Features grid ── */}
      <section className="doctif-shell" style={{ position: 'relative', zIndex: 5, paddingBottom: 60 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h2 className="doctif-fade-up" style={{
            fontFamily: "'Syne', sans-serif", fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            fontWeight: 700, letterSpacing: '-0.03em',
          }}>
            Tout ce dont vous avez besoin,
            <br /><span style={{
              background: 'linear-gradient(135deg, #93c5fd, #c4b5fd)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
            }}>rien de superflu.</span>
          </h2>
        </div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14,
        }}>
          {features.map((f, i) => (
            <article key={f.title} className={`doctif-fade-up doctif-delay-${Math.min(i + 1, 5)}`} style={{
              background: 'rgba(255,255,255,0.6)', backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255,255,255,0.8)', borderRadius: 20,
              padding: '24px 20px',
              boxShadow: '0 8px 30px -15px rgba(147,197,253,0.15)',
              transition: 'transform 0.3s, box-shadow 0.3s',
              cursor: 'default',
            }}
              onMouseEnter={e => { (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)'; (e.currentTarget as HTMLElement).style.boxShadow = '0 16px 50px -20px rgba(147,197,253,0.3)'; }}
              onMouseLeave={e => { (e.currentTarget as HTMLElement).style.transform = ''; (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 30px -15px rgba(147,197,253,0.15)'; }}
            >
              <div style={{ fontSize: 28, marginBottom: 12 }}>{f.icon}</div>
              <h3 style={{ fontFamily: "'Syne', sans-serif", fontSize: 18, fontWeight: 700, marginBottom: 8, color: '#1a1a2e' }}>{f.title}</h3>
              <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.65 }}>{f.desc}</p>
            </article>
          ))}
        </div>
      </section>

      {/* ── Testimonials ── */}
      <section className="doctif-shell" style={{ position: 'relative', zIndex: 5, paddingBottom: 50 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {testimonials.map(t => (
            <blockquote key={t.name} className="doctif-fade-up" style={{
              background: 'rgba(255,255,255,0.5)', backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.8)', borderRadius: 20,
              padding: '24px 22px', margin: 0,
            }}>
              <p style={{ fontSize: 16, lineHeight: 1.7, color: '#374151', fontStyle: 'italic', marginBottom: 14 }}>"{t.text}"</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #93c5fd, #c4b5fd)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 14, fontWeight: 700, color: '#fff',
                }}>{t.name[0]}{t.name.split(' ')[1]?.[0]}</div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1a1a2e' }}>{t.name}</div>
                  <div style={{ fontSize: 12, color: '#9ca3af' }}>{t.role}</div>
                </div>
              </div>
            </blockquote>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="doctif-shell" style={{ position: 'relative', zIndex: 5, paddingBottom: 60 }}>
        <div style={{
          background: 'linear-gradient(135deg, #1a1a2e, #2a2a4e)', borderRadius: 24,
          padding: '50px 40px', textAlign: 'center',
          boxShadow: '0 30px 60px -20px rgba(26,26,46,0.3)',
        }}>
          <h2 style={{
            fontFamily: "'Syne', sans-serif", fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
            fontWeight: 700, color: '#fff', marginBottom: 14,
          }}>
            Prêt à simplifier votre quotidien ?
          </h2>
          <p style={{ color: '#9ca3af', maxWidth: 460, margin: '0 auto 24px', lineHeight: 1.7 }}>
            Créez votre espace en quelques minutes. Gratuit pendant 30 jours, sans engagement.
          </p>
          <a href="/accounts/login/" style={{
            display: 'inline-block', background: '#fff', color: '#1a1a2e',
            padding: '14px 32px', borderRadius: 14, fontWeight: 700, fontSize: 16,
            textDecoration: 'none', boxShadow: '0 8px 30px rgba(255,255,255,0.15)',
          }}>
            Commencer maintenant
          </a>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{ borderTop: '1px solid #e5e7eb', position: 'relative', zIndex: 5 }}>
        <div className="doctif-shell" style={{
          padding: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <span style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 18, color: '#d1d5db' }}>
            doctif<span style={{ color: '#93c5fd' }}>.</span>
          </span>
          <span style={{ color: '#d1d5db', fontSize: 12 }}>Direction aurora — Version 03</span>
        </div>
      </footer>

      <style>{`
        @media (max-width: 860px) {
          section div[style*='grid-template-columns: repeat(3'] { grid-template-columns: 1fr !important; }
          section div[style*='grid-template-columns: 1fr 1fr'] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
